/* eslint-disable-next-line no-unused-vars */
const productPropertiesInterface = `
	id
	sku
	name
	campaign_discount_price
	campaign_discount_disclaimer
	related_samples {
		name
		sku
		stock_status
	}
	promo_label_data {
        name
        image
        priority
    }
	subscription {
		is_subscription_enabled
		min_qty
		max_qty
	}
	brand
	comdty_code
	product_code
	image {
		url
		label
	}
	small_image {
		url
		label
	}
	media_gallery {
	   url
	   disabled
		... on ProductVideo {
			video_content {
				video_url
			}
       }
	}
	price_range {
		maximum_price {
			regular_price {
				value
				currency
			}
		}
		minimum_price {
			regular_price {
				value
				currency
			}
			final_price {
				value
				currency
			}
			discount {
				amount_off
				percent_off
			}
		}
	}
	stock_status
	type_id
	max_qty
	short_description {
		html
	}
	product_ribbon_label_name
	parent_id
	rating_summary
	review_count
	glojp_aem_url
	
`;
const productPropertiesInterfacePLP = `
	id
	sku
	name
	campaign_discount_price
	campaign_discount_disclaimer
	comdty_code
	promo_label_data {
        name
        image
        priority
    }
	subscription {
		is_subscription_enabled
		min_qty
		max_qty
	}
	price_range {
		maximum_price {
			regular_price {
				value
				currency
			}
		}
		minimum_price {
			regular_price {
				value
				currency
			}
			final_price {
				value
				currency
			}
			discount {
				amount_off
				percent_off
			}
		}
	}
	stock_status
	type_id
	max_qty
	product_ribbon_label_name
	glojp_aem_url
	parent_id
	image {
		url
		label
	}
	small_image {
		url
		label
	}
`;
const productPropertiesInterfaceCart = `
	id
	sku
	name
	subscription {
		is_subscription_enabled
		min_qty
		max_qty
	}
	small_image {
		url
		label
	}
	price_range {
		maximum_price {
			regular_price {
				value
				currency
			}
		}
		minimum_price {
			regular_price {
				value
				currency
			}
			final_price {
				value
				currency
			}
			discount {
				amount_off
				percent_off
			}
		}
	}
	stock_status
	type_id
	max_qty
	glojp_aem_url
	comdty_code
`;
const productPropertiesInterfaceSort = `
    id
    sku
    name
	campaign_discount_price
	campaign_discount_disclaimer
    price_range {
        maximum_price {
            regular_price {
                value
                currency
            }
        }
        minimum_price {
            regular_price {
                value
                currency
            }
            final_price {
                value
                currency
            }
            discount {
                amount_off
                percent_off
            }
        }
    }  
    glojp_aem_url
`;
/* eslint-disable-next-line no-unused-vars */
const productReviewsInterface = `
	rating_summary
	review_count
	reviews (
		pageSize: 50
    currentPage: 1)
	{
		items {
			summary
			text
			nickname
			created_at
			ratings_breakdown {
				name
				value
			}
		}
	}
`;

const customProductPropertiesInterface = `
	purchase_type
	purchase_type_label
	glo_jp_colour
	glo_jp_colour_value
	glo_jp_flavour
	glo_jp_flavour_value
	glo_jp_flavour_type
	glo_jp_flavour_type_value
	glo_jp_material
	glo_jp_material_value
	glo_strength_fragnance
	glo_strength_fragnance_capsule
	glo_strength_fragnance_label
	glo_strength_tobacco
	glo_strength_tobacco_capsule
	glo_strength_tobacco_label
	glo_strength_menthol
	glo_strength_menthol_capsule
	glo_strength_menthol_label
	glo_strength_intake
	glo_strength_intake_capsule
	glo_strength_intake_label
	glo_hyper_side_panel_colour
	glo_hyper_main_body_colour
	velo_jp_barometer_strength
	velo_jp_barometer_strength_value
	velo_jp_barometer_strength_label
	velo_jp_scent
	velo_jp_scent_label
	velo_jp_cold_feeling
	velo_jp_cold_feeling_label
	velo_jp_strength
	velo_jp_strength_value
	velo_jp_strength_label
	velo_jp_star_color_label
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	campain_description
	jp_campaign_any
	jp_campaign_new_joiner
	jp_campaign_pre_launch
	jp_campaign_bundle
	glovelo_suggestion_sku
	remix_carton
	min_qty
	max_qty
`;
const customProductPropertiesInterfaceSort = `
	glo_jp_colour
	glo_jp_colour_value
	glo_jp_flavour
	glo_jp_flavour_value
	glo_jp_flavour_type
	glo_jp_flavour_type_value
	glo_jp_material
	glo_jp_material_value
	
	
	velo_jp_barometer_strength
	velo_jp_barometer_strength_value
	
	
	velo_jp_strength
	velo_jp_strength_value
	
	
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	
`;
const customProductPropertiesInterfaceCart = `
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	
	
`;
const customProductPropertiesInterfacePLP = `
	purchase_type
	purchase_type_label
	glo_jp_colour
	glo_jp_colour_value
	glo_jp_flavour
	glo_jp_flavour_value
	glo_jp_flavour_type
	glo_jp_flavour_type_value
	glo_jp_material
	glo_jp_material_value
	glo_strength_fragnance
	glo_strength_fragnance_capsule
	glo_strength_fragnance_label
	glo_strength_tobacco
	glo_strength_tobacco_capsule
	glo_strength_tobacco_label
	glo_strength_menthol
	glo_strength_menthol_capsule
	glo_strength_menthol_label
	glo_strength_intake
	glo_strength_intake_capsule
	glo_strength_intake_label
	glo_hyper_side_panel_colour
	glo_hyper_main_body_colour
	velo_jp_barometer_strength
	velo_jp_barometer_strength_value
	velo_jp_barometer_strength_label
	velo_jp_scent
	velo_jp_scent_label
	velo_jp_cold_feeling
	velo_jp_cold_feeling_label
	velo_jp_strength
	velo_jp_strength_value
	velo_jp_strength_label
	velo_jp_star_color_label
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	jp_campaign_any
	jp_campaign_new_joiner
	jp_campaign_pre_launch
	jp_campaign_bundle
	glovelo_suggestion_sku
	remix_carton
`;
// velo_jp_flavour
// velo_jp_flavour_value
// jp_bundle_type_value
// glo_jp_has_capsule
// glo_jp_has_capsule_value

/* eslint-disable-next-line no-unused-vars */
const categoryListInterface = `
	id
	name
	products {
		items {
			${customProductPropertiesInterfaceSort}
			${productPropertiesInterfaceSort}
			velo_jp_flavour
			velo_jp_flavour_value
			velo_jp_strength
			velo_jp_strength_value
			glo_jp_has_capsule 
			glo_jp_has_capsule_value
		}
	}
	product_count
	children {
		id
		name
		products {
			items {
				${customProductPropertiesInterfaceSort}
				${productPropertiesInterfaceSort}
				glo_jp_has_capsule 
				glo_jp_has_capsule_value
			}
		}
	}
`;

/* eslint-disable-next-line no-unused-vars */
const configurableInterface = `
	... on ConfigurableProduct {
		configurable_options {
			attribute_code
			label
			values {
				label
				value_index
				eng_label
			}
		}
		variants {
			product {
				${customProductPropertiesInterface}
				${productPropertiesInterface}
			}
		}
	}
`;
const configurableInterfacePLP = `
	... on ConfigurableProduct {
		configurable_options {
			attribute_code
			label
			values {
				label
				value_index
				eng_label
			}
		}
		variants {
			product {
				${customProductPropertiesInterfacePLP}
				${productPropertiesInterfacePLP}
			}
		}
	}
`;
/* eslint-disable-next-line no-unused-vars */
const bundleInterface = `
	... on BundleProduct {
		items {
			option_id
			options {
				id
				label
				price
				price_type
				product {
					${productPropertiesInterface}
				}
				quantity
			}
			sku
			title
			type
		}
		price_view
		ship_bundle_items
	}
`;
const bundleInterfacePLP = `
	... on BundleProduct {
		items {
			option_id
			required
			options {
				id
				label
				price
				price_type
				product {
					${productPropertiesInterfacePLP}
				}
				quantity
			}
			sku
			title
			type
		}
		price_view
		ship_bundle_items
	}
`;

/* eslint-disable-next-line no-unused-vars */
const relatedProductsInterface = `
	related_products {
		${productPropertiesInterface}
		${configurableInterface}
	}
`;
const relatedProductsInterfacePLP = `
	related_products {
		${productPropertiesInterfacePLP}
		${configurableInterfacePLP}
	}
`;

/* eslint-disable-next-line no-unused-vars */
const cartInterface = `
	items (sortBySubscription: SUBSCRIPTION_FIRST) {
		id
		tax_percent
		product {
			${productPropertiesInterfaceCart}
			${customProductPropertiesInterfaceCart}
			... on BundleProduct {
			  items {
				option_id
				options {
				  id
				  label
				  product {
					id
					sku
					name
					comdty_code
					glojp_aem_url
					stock_status
					jp_bundle_type
					price_range {
					  minimum_price {
						final_price {
						  value
						  currency
						}
					  }
					}
				  }
				}
			  }
			}
		}
		prices {
			discounts {
				label
			}
			row_total_including_tax {
				value
				 currency
			}
		}
		... on BundleCartItem {
            bundle_options {
                id
                label
                values {
                	id
                    label
                    quantity
                }
            }
        }
		... on ConfigurableCartItem {
			configurable_options {
				id
				option_label
				value_label
			}
		}
		quantity
		subscription_data {
			is_subscription_item
		}
	}
	prices {
		discounts {
			amount {
				value
				currency
			}
			label
		}
		grand_total {
			value
			currency
		}
		subtotal_including_tax {
			value
			currency
		}
		
	}
	customprices {
		grand_total_excluding_shipping_payment_fees {
			value
			currency
		}
	}
	total_quantity
`;
